import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import Magnetic from "@/components/motion/Magnetic";
import MenuDrawer from "@/components/MenuDrawer";
import { nav } from "@/data/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-[100] transition-colors duration-500 ${
        scrolled ? "bg-bone/85 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-5 md:h-20 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <Link to="/" data-testid="logo-link" className="flex items-center leading-none">
          <img
            src="/hashtag-logo.png"
            alt="HashTag"
            className="h-9 w-auto transition-transform duration-300 hover:scale-[1.04] md:h-11"
          />
        </Link>

        <ul className="hidden items-center gap-8 lg:flex">
          {nav.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `link-underline text-sm font-semibold uppercase tracking-[0.12em] transition-colors ${
                    isActive ? "text-accent" : "text-ink hover:text-accent"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4">
          <Magnetic strength={0.25} className="hidden md:inline-block">
            <Link
              to="/contact"
              data-testid="nav-cta"
              className="group inline-flex items-center gap-2 border border-ink bg-ink px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-bone transition-colors duration-300 hover:bg-accent hover:border-accent"
            >
              Discuss a Project
            </Link>
          </Magnetic>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="group flex items-center gap-2 lg:hidden"
          >
            <Menu size={26} className="transition-colors group-hover:text-accent" />
          </button>
        </div>
      </nav>

      <MenuDrawer open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
